import { render, staticRenderFns } from "./FabricanteForm.vue?vue&type=template&id=3c45a397&scoped=true"
import script from "./FabricanteForm.vue?vue&type=script&lang=js"
export * from "./FabricanteForm.vue?vue&type=script&lang=js"
import style0 from "./FabricanteForm.vue?vue&type=style&index=0&id=3c45a397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45a397",
  null
  
)

export default component.exports